import * as core from '../../../../../../../core'
import * as innovationTracker from '../innovation-tracker'

export const RESOURCE = {
  payload: {
    alias: 'ideas.list',
    appAlias: innovationTracker.RESOURCE.payload.alias,
    description: "Explore Ideas in Innovation's pipeline",
    display: {
      isMain: true,
      position: 2,
    },
    name: 'Ideas',
    page: { alias: 'ideas.list' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
